import React from 'react';
import { CircleDashed } from 'lucide-react';
import { ESTADO_ICONO, ESTADO_LABEL, ESTADO_PILL } from 'lib/estadoUi';

// Píldora de estado del asistente: color, ícono y texto de lib/estadoUi (los
// mismos de las pantallas administrativas), en tamaño grande para el celular.
// Sin estado: "Sin marcar" en neutro con su propio ícono.
export default function EstadoPill({ estado }) {
  const Icono = ESTADO_ICONO[estado] || CircleDashed;
  const tono = ESTADO_PILL[estado] || 'border-foreground/30 bg-white text-foreground';
  return (
    <span
      data-estado={estado || 'sin-marcar'}
      className={`inline-flex shrink-0 items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-sm font-bold ${tono}`}
    >
      <Icono size={16} strokeWidth={2.5} aria-hidden="true" />
      {ESTADO_LABEL[estado] || 'Sin marcar'}
    </span>
  );
}
